import {ColDef, ColType} from "../interfaces/colDef";
import {ClientStatus} from "../interfaces/client";
import {BSValidators} from "../shared/bsvalidators";

export const stickyColumns: ColDef[] = [{
  name: 'name',
  subtitle: 'explain.client.name',
  type: ColType.STRING,
  required: true,
  title: 'name',
  validators: [
    BSValidators.required
  ],
  group: 1
}];

export const stickyScheduleColumns: ColDef[] = [{
  name: 'name',
  subtitle: 'explain.client.name',
  type: ColType.STRING,
  required: true,
  disabled: true,
  title: 'name',
  filter: false,
  sort: false
}];

export const scheduleColumns: ColDef[] = [
  {
    name: 'scheduled',
    title: 'scheduledhours',
    required: false,
    type: ColType.INT,
    filter: false,
    sort: true
  },
  {
    name: 'offered',
    title: 'offeredtotal',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'cost',
    title: 'cost',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'value',
    title: 'forcastvalue',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'margin',
    title: 'forcastmargin',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'duration',
    title: 'tracking.trackedtime',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CUSTOM
  },
  {
    name: 'tracked_amount',
    title: 'tracking.tracked_amount',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'tracked_scheduled',
    title: 'tracking.tracked_scheduled',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'tracked_budget',
    title: 'tracking.tracked_budget',
    required: false,
    filter: false,
    sort: true,
    type: ColType.CURRENCY
  },
  {
    name: 'num_members',
    title: 'totalmembers',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'num_projects',
    title: 'totalprojects',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'workingdays',
    title: 'workingdays',
    required: false,
    filter: false,
    sort: true,
    type: ColType.INT
  },
  {
    name: 'max_score',
    title: 'score',
    required: false,
    sort: true,
    filter: false,
    type: ColType.INT,
    noexport: true
  }
];

export const otherDefs: ColDef[] = [
  {
    title: 'status',
    name: 'status',
    type: ColType.RADIO,
    required: true,
    list: [
      {
        id: ClientStatus.ACTIVE,
        name: 'Active'
      },
      {
        id: ClientStatus.ARCHIVED,
        name: 'Inactive'
      }
    ]
  }
];

// Prospects-tab column (table-object.component). Surfaces the prospect
// lifecycle status per row; the cell template maps the numeric Client status
// to a coloured pill (see TableObjectComponent.prospectStatusKey).
export const prospectColumns: ColDef[] = [
  {
    name: 'prospect_status',
    title: 'status',
    type: ColType.STRING,
    required: false,
    filter: false,
    sort: false
  }
];


export const columns: ColDef[] = [
  {
    name: 'description',
    subtitle: 'explain.client.description',
    title: 'description',
    required: false,
    type: ColType.AREA,
    group: 1
  },
  {
    name: 'matching_description',
    subtitle: 'explain.client.matchingdescription',
    title: 'matchingdescription',
    required: false,
    type: ColType.AREA,
    group: 1
  },
  {
    name: 'address',
    subtitle: 'explain.client.address',
    title: 'address',
    required: false,
    type: ColType.STRING,
    group: 1
  },
  {
    name: 'email',
    subtitle: 'explain.client.email',
    title: 'email',
    required: false,
    type: ColType.STRING,
    validators: [
      // BSValidators.required,
      BSValidators.email
    ],
    group: 1
  },
  {
    name: 'phone',
    subtitle: 'explain.client.phone',
    title: 'phone',
    required: false,
    type: ColType.STRING,
    validators: [
      BSValidators.phoneValid
    ],
    group: 1
  },
  {
    name: 'url',
    subtitle: 'explain.client.url',
    title: 'url',
    required: false,
    type: ColType.STRING,
    group: 1,
    validators: [
      BSValidators.web()
    ]
  },
  {
    name: 'project',
    subtitle: 'explain.client.projects',
    title: 'projects',
    required: false,
    type: ColType.LISTADDER
  }
];

